import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { ResendInviteEmail } from '../mutations/resendInviteEmail.mutation';
import type { ResendInviteEmailMutation, ResendInviteEmailMutationVariables } from '../types';

export const useResendInviteEmailMutation = (
  options?: MutationOptions<ResendInviteEmailMutation, ResendInviteEmailMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(ResendInviteEmail), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('user'),
      });
    },
  });
};
